/**
 * Configuration file for NACHA CSV processor
 * 
 * This file contains company presets for the NACHA converter application,
 * allowing users to quickly select from predefined company configurations
 * rather than entering all information manually.
 * 
 * Each preset includes:
 * - Company name and ID (limited to 16 characters)
 * - Tax ID/Company identification number
 * - Bank routing numbers
 * - Other ACH transfer requirements
 * 
 * The presets are configured for three major banks:
 * 1. Chase Bank
 * 2. Bank of America
 * 3. Wells Fargo
 * 
 * Created by Richard McGirr
 */

/**
 * Company configuration presets
 * 
 * This array contains predefined company configurations that users can select
 * to quickly populate the NACHA configuration form without manual data entry.
 * 
 * @type {Array<Object>}
 */

// Using just one fixed preset for now, to be re-implemented with full UI later
const companyPresets = [
  {
    id: 'property-llama',
    name: 'Property Llama Capital',
    config: {
      immediateDestination: '021000021', // Chase Bank routing number
      immediateOrigin: '1234567890',     // Company ID  
      companyName: 'PROPERTY LLAMA CAP', // Company name (max 16 chars)
      companyIdentification: '1234567890', // Tax ID or company ID
      originatingDFI: '021000021',       // Financial institution routing number
    }
  }
];

/*
// Original full presets - commented out for future re-implementation
const companyPresets = [
  {
    id: 'property-llama',
    name: 'Property Llama Capital',
    config: {
      immediateDestination: '021000021', // Chase Bank routing number
      immediateOrigin: '1234567890',     // Company ID
      companyName: 'PROPERTY LLAMA CAP', // Company name (max 16 chars)
      companyIdentification: '1234567890', // Tax ID or company ID
      originatingDFI: '021000021',       // Financial institution routing number
    }
  },
  {
    id: 'mountain-view',
    name: 'Mountain View Investments',
    config: {
      immediateDestination: '026009593', // Bank of America routing number
      immediateOrigin: '9876543210',     // Company ID
      companyName: 'MOUNTAIN VIEW INV', // Company name (max 16 chars)
      companyIdentification: '9876543210', // Tax ID or company ID
      originatingDFI: '026009593',       // Financial institution routing number
    }
  },
  {
    id: 'denver-holdings',
    name: 'Denver Holdings LLC',
    config: {
      immediateDestination: '121000248', // Wells Fargo routing number
      immediateOrigin: '5678901234',     // Company ID
      companyName: 'DENVER HOLDINGS', // Company name (max 16 chars)
      companyIdentification: '5678901234', // Tax ID or company ID
      originatingDFI: '121000248',       // Financial institution routing number
    }
  }
];
*/

/**
 * Export company presets for use in the main application
 * This makes the company configuration data available to import in App.js
 */
export { companyPresets };